// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_uc-0";